import React from 'react'
import { useNavigate } from 'react-router-dom';
import InfoIcon from '@mui/icons-material/Info';

const ItemCard = ({ item, order = null }) => {
    const navigate = useNavigate();
    const { dish_category, price, food_name, id, food_image_json } = item;

    return (
        <div
            onClick={() => navigate(`/dashboard/menu-items/${id}`, { state: order })}
            className='rounded-lg overflow-hidden shadow-lg w-[100%] cursor-pointer hover:scale-95 duration-300'>
            <img src={food_image_json[0]?.url} alt={food_name} className='h-32 object-cover w-full' />

            <div className='p-2 pr-0 w-[150px] lg:w-[200px]'>
                <h2 className='font-bold truncate'>{food_name?.charAt(0).toUpperCase() + food_name?.slice(1).toLowerCase()}</h2>
                <div className='flex flex-row items-center space-x-1'>
                    <InfoIcon sx={{ fontSize: 12, mt: .3 }} />
                    <p className='text-sm'>{dish_category}</p>
                </div>
                <h2 className='text-sm font-bold text-primary'> {price?.toLocaleString("en", {
                    style: "currency",
                    currency: "KSH",
                })}</h2>
            </div>
        </div>
    )
}

export default ItemCard